import { render, staticRenderFns } from "./RecuperarView.vue?vue&type=template&id=3166865e&"
import script from "./RecuperarView.vue?vue&type=script&lang=ts&"
export * from "./RecuperarView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports